import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineMemberAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if (permissions.some(p => p === AuthAuthPermissions.SYSTEM_MANAGEMENT)) {
    can('crud', 'Member')
  }
}
